import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import SearchInput from "@/components/SearchInput/SearchInput";
import { ProductStoreProduct } from "../../api/fetchProductStoreProducts/types";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import DeleteProductModal from "../DeleteProductModal/DeleteProductModal";
import { useProductList } from "../../hooks/useProductList";

const ProductList: React.FC = () => {
  const {
    products,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    filters,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
    columns,
    deleteDialogState,
    closeDeleteDialog,
    handleConfirmDelete,
    goToCreateProduct,
  } = useProductList();

  return (
    <MainPageWrapper
      actions={
        <Button
          className="flex items-center gap-1"
          onClick={goToCreateProduct}
          size="sm"
        >
          <Plus className="w-4 h-4" />
          New Product
        </Button>
      }
      error={error}
      subtitle="Manage your product catalog"
      title="Products"
    >
      <div className="mb-4 flex items-center space-x-2">
        <div className="max-w-md w-full">
          <SearchInput
            onChange={(searchTerm: string) => handleFilterChange(searchTerm)}
            placeholder="Search products by name or code..."
            value={filters.searchTerm || ""}
          />
        </div>
        <select
          className="px-3 py-2 pr-10 flex h-9 rounded-md border border-input bg-white text-base shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring md:text-sm dark:bg-slate-800 dark:border-slate-700 dark:text-slate-100"
          onChange={(e) =>
            handleFilterChange(
              filters.searchTerm || "",
              parseInt(e.target.value, 10),
            )
          }
          value={filters.isActive}
        >
          <option value={1}>Active</option>
          <option value={0}>Inactive</option>
        </select>
      </div>
      <div className="relative">
        <DataTable<ProductStoreProduct>
          columns={columns}
          data={products}
          error={error}
          loading={loading}
          noDataMessage="No products found. Create one to get started."
          onPageChange={(newPageIndex, newPageSize) =>
            handlePaginationChange({
              pageIndex: newPageIndex,
              pageSize: newPageSize,
            })
          }
          onSortingChange={handleSortingChange}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          rowKeyExtractor={(item) => item.id}
          sorting={sorting}
          totalCount={totalCount}
        />
      </div>

      <DeleteProductModal
        isOpen={deleteDialogState.isOpen}
        onClose={closeDeleteDialog}
        onConfirm={handleConfirmDelete}
        productName={deleteDialogState.productName}
      />
    </MainPageWrapper>
  );
};

export default ProductList;
